import { DynamicPage } from '../DynamicPage';

export const DynamicStaticPage = DynamicPage;
